import region from './components/region.vue';


export default {
  routes: [
    {
      path: '/',
      component:region,
      name:'region'
    },
  ]
}
